import Api from 'common/api'

import types from './types'

const fetchUpcomingVisits = (highSchoolId) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_UPCOMING_VISITS_START,
    })

    Api.get(`/api/highschools/${highSchoolId}/visits/upcoming?limit=3`)
      .then((result) => {
        dispatch({
          type: types.UPDATE_UPCOMING_VISITS,
          payload: result,
        })
      })
      .catch(() => {
        dispatch({
          type: types.FETCH_UPCOMING_VISITS_FAILURE,
        })
      })
  }
}
const updateUpcomingVisits = (visits) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_UPCOMING_VISITS,
      payload: visits,
    })
  }
}

export default {
  fetchUpcomingVisits,
  updateUpcomingVisits,
}
